module.exports = __webpack_public_path__ + "static/media/pg32.40726c01.jpg";